<wm-form-activity-input-view [activity]="activity" [form]="form" [showSubmitButton]="false" [isReadOnly]="true">
</wm-form-activity-input-view>
